module.exports = __webpack_public_path__ + "static/Burst_1s-74ac37e34a6ca655a38dc812448f21d3.jpg";